<div class="main-declare" style="height: 100%;">
    <div class="container">
        <button class="btn btn-secondary btn-sm my-3" routerLink="/" >RETOUR</button>
        <app-statistic></app-statistic>


        <div class="row my-5">
            <div class="col-sm-3 block">
                <div class="block-nbr">
                    <span class="nbr-block">{{ totalCasess}}</span><br/> CAS CONFIRMÉ
                </div>
            </div>
            <div class="col-sm-3 block">
                <div class="block-nbr">
                    <span class="nbr-block">{{ NewCases}}</span><br/> NOUVEAUx CAS
                </div>
            </div>

            <div class="col-sm-3 block">
                <div class="block-nbr">
                    <span class="nbr-block">{{ restedHumans }}</span><br/> RÉTABLI
                </div>
            </div>
            
            <div class="col-sm-3 block">
                <div class="block-nbr"><span class="nbr-block">{{ suspectedCases}}</span><br/> CAS SUSPECTS
                </div>
            </div>

            <div class="col-sm-3 block">
                <div class="block-nbr"><span class="nbr-block">{{ nbgOfDeath}}</span><br/> DÉCÈS
                </div>
            </div>

            
            <div class="col-sm-3 block">
                <div class="block-nbr">
                    <span class="nbr-block">{{ quarentaine }}</span><br/> NB QUARANTAINE
                </div>
            </div>
            

                        


                 
        </div>

    </div>

</div>